import { Link } from "gatsby";
import PropTypes from "prop-types";
import React from "react";

import { ingestData } from "../../bridges/BridgeServices";
import { EVENTS } from "../../utils/constants";
import { createRedirectURL } from "../../utils/helperFunctions";
import "./sideNavbarItem.scss";

const SideNavbarItem = ({
  uri = "",
  allPagesData = {},
  activeChild = false,
}) => {
  const { title = "", thumbnailUrl = "" } =
    allPagesData[uri] || {};

  return (
    <Link
      to={createRedirectURL(uri)}
      onClick={() => {
        ingestData({
          name: EVENTS.FAQ_SUBCATEGORY_CLICKED,
        });
      }}
    >
      <div className="side-navbar-item">
        {thumbnailUrl ? (
          <div className="side-navbar-item-icon">
            {thumbnailUrl ? <img src={thumbnailUrl} /> : ""}
          </div>
        ) : (
          ""
        )}
        <div
          className={
            "side-navbar-item-title" +
            (activeChild ? " active-title" : "")
          }
        >
          {title}
        </div>
      </div>
    </Link>
  );
};

SideNavbarItem.propTypes = {
  uri: PropTypes.string,
  allPagesData: PropTypes.object,
  activeChild: PropTypes.bool,
};

export default SideNavbarItem;
